module.exports = __webpack_public_path__ + "media/concept_job-7b89fd7f89935577d9727df5917479d6.svg";